import React from 'react'

const About = () => {
  return (
    <div className="topmost-about">
      <h4>
        About
      </h4>
      <p>
        Topmost Wears was established with the initiative of offering high end clothing to retailers and users in the target market. It focuses on luxurious brands from across the globe. They have stores built across states in Nigeria but also reach out digitally to customers through an online ecommerce website.
        The company has been focusing on facilitating online requests ansd processing the delivery of goods to the door steps of customers, a need that is now more urgent due to the outbreak of Covid-19 and lockdown measures across the country.
        Topmost is pushing to be major source of wears and is pushing its business on online social platforms at a very high over the past few years.
      </p>
    </div>
  )
}

export default About